import { capitalize } from 'lodash'

import Payment from '@/models/payment'

export default class PaymentInfoBaseService {
  payment: Payment

  constructor(payment: Payment) {
    this.payment = payment
  }

  call(): string {
    return `${this.actionPerformed} ${this.meansOfPayment}`
  }

  get meansOfPayment(): string {
    const { payment } = this

    switch (payment.payType) {
      case 'bank':
        return 'by Bank Transfer'
      case 'credit':
        return 'received a Credit'
      case 'card':
        return payment.cardBrand.length
          ? `by ${capitalize(payment.cardBrand)}`
          : 'by Card'
      default:
        return `by ${capitalize(payment.payType)}`
    }
  }

  get actionPerformed(): string {
    return ''
  }

  get actionSuffix(): string {
    return ''
  }
}
